import type { I18N } from '.';

export const de = {
  loginWith: 'Anmelden mit',
  approveWith: 'Genehmigen mit',
  signWith: 'Unterschreiben mit',
  confirmWith: 'Bestätigen mit',
  acceptWith: 'Akzeptieren mit',
  sameDevice: 'Auf diesem Gerät',
  anotherDevice: 'Mit Ihrer Sozialversicherungsnummer',
  anotherDeviceQR: 'Auf einem anderen Gerät',
  mitidBusiness: 'MitID Business',
  finnishMobileID: 'Finnischem Mobilfunkzertifikat',
  finnishBankID: 'Finnische BankID',
  swedishBankID: 'Schwedische BankID',
  norwegianBankID: 'Norwegische BankID',
  biometrics: 'Biometrie',
  openAndScan: 'Öffnen Sie die BankID-App auf Ihrem mobilen Endgerät und scannen Sie den QR-Code.',
  thisIsTheQR:
    'Dies ist ein BankID QR-Code. Sie können darauf klicken, um ihn im Vollbildmodus anzuzeigen',
  completingLogin: 'Ihre Anmeldung wird abgeschlossen.',
} satisfies I18N;
